import helpContent from './helpContent.json';

// Articles link app pages as https://bumpups.com/… in a new tab; in the app they open in place
// (and in the current environment), handled by HelpArticle's click handler
const inAppLinks = html => html.replace(
  /<a ([^>]*)href="https:\/\/bumpups\.com(\/[^"]*)"([^>]*)>/g,
  (_, before, appPath, after) => `<a ${before}href="${appPath}"${after}>`.replace(/ target="_blank"/, ''),
);

export const helpCollections = helpContent.collections;
export const helpArticles = helpContent.articles.map(article => ({ ...article, bodyHtml: inAppLinks(article.bodyHtml) }));

export const articleBySlug = helpArticles.reduce((acc, article) => {
  acc[article.slug] = article;
  return acc;
}, {});

export const collectionBySlug = helpCollections.reduce((acc, collection) => {
  acc[collection.slug] = collection;
  return acc;
}, {});

export const getArticlesForCollection = (collectionSlug) => {
  const collection = collectionBySlug[collectionSlug];
  if (!collection) return [];

  return collection.articleSlugs
    .map((articleSlug) => articleBySlug[articleSlug])
    .filter(Boolean);
};

export const getRelatedArticles = (article) => {
  if (!article?.relatedSlugs?.length) return [];

  return article.relatedSlugs
    .map((articleSlug) => articleBySlug[articleSlug])
    .filter(Boolean)
    .slice(0, 5);
};

// Each search word scores where it appears — title 3, description 2, body or topic 1 — and the
// best-scoring articles come first. Filler words are ignored so a question like "how do I cancel
// my plan" searches cancel + plan.
const FILLER = new Set(['a', 'an', 'and', 'can', 'do', 'does', 'for', 'how', 'i', 'in', 'is', 'it', 'my', 'of', 'on', 'or', 'the', 'to', 'what', 'with']);

export const searchHelpArticles = (query) => {
  const allWords = query.toLowerCase().split(/\s+/).filter(Boolean);
  const keywords = allWords.filter((word) => !FILLER.has(word));
  const words = keywords.length ? keywords : allWords;
  if (!words.length) return [];

  return helpArticles
    .map((article) => {
      const title = article.title.toLowerCase();
      const description = (article.description || '').toLowerCase();
      const rest = `${article.searchableText} ${collectionBySlug[article.collectionSlug]?.title || ''}`.toLowerCase();
      const score = words.reduce((sum, word) => sum + (
        title.includes(word) ? 3 : description.includes(word) ? 2 : rest.includes(word) ? 1 : 0
      ), 0);
      return { article, score };
    })
    .filter(({ score }) => score > 0)
    .sort((a, b) => b.score - a.score)
    .map(({ article }) => article);
};
